import { collection, doc, writeBatch, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase/config';

// Find a client by their national ID and phone number
export const findClientByDetails = async (nationalId: string, phoneNumber: string) => {
  const usersRef = collection(db, 'users');
  const q = query(usersRef, where('nationalId', '==', nationalId), where('phone', '==', phoneNumber), where('role', '==', 'client'));
  
  const querySnapshot = await getDocs(q);
  
  if (querySnapshot.empty) {
    return null;
  }
  
  // Assuming nationalId and phoneNumber combination is unique for clients
  const clientDoc = querySnapshot.docs[0];
  return { id: clientDoc.id, ...clientDoc.data() };
};

// Create a new contract, its payments, a notification, and an activity log entry
export const createContract = async (contractData: any) => {
  const batch = writeBatch(db);

  // 1. Create the contract document
  const contractRef = doc(collection(db, 'contracts'));
  batch.set(contractRef, {
    title: contractData.details.title,
    description: contractData.details.description,
    amount: contractData.details.totalAmount, // Renamed from totalAmount
    currency: 'ر.س',
    clientId: contractData.details.clientId,
    lawyerId: contractData.details.lawyerId,
    status: 'معلق', // بانتظار موافقة العميل
    createdAt: new Date(),
    dueDate: contractData.payments[0]?.dueDate ? new Date(contractData.payments[0].dueDate) : new Date(), // Use first payment's due date
    id: contractRef.id, // Keep for reference if needed, though Firestore docs have their own ID
  });

  // 2. Create payment documents
  contractData.payments.forEach((payment: any, index: number) => {
    const paymentRef = doc(collection(db, `contracts/${contractRef.id}/payments`));
    batch.set(paymentRef, {
      amount: payment.amount,
      dueDate: new Date(payment.dueDate),
      status: index === 0 ? 'مستحق' : 'مستقبلي', // First payment is due, others are future
      id: paymentRef.id,
    });
  });

  // 3. Create a notification for the client
  const notificationRef = doc(collection(db, 'notifications'));
  batch.set(notificationRef, {
    userId: contractData.details.clientId,
    message: `عقدك مع ${contractData.details.lawyerName} بانتظار الموافقة`,
    createdAt: new Date(),
    read: false,
    contractId: contractRef.id,
  });

  // 4. Create an activity log for the lawyer
  const activityRef = doc(collection(db, `users/${contractData.details.lawyerId}/activities`));
  batch.set(activityRef, {
    id: activityRef.id,
    description: `قمت بتسجيل عقد جديد لـ ${contractData.details.clientName}`,
    type: 'contract_created',
    timestamp: new Date(),
  });

  // Commit the batch
  await batch.commit();

  return { contractId: contractRef.id };
};
